import React from 'react';
import PropTypes from 'prop-types';
import LoadingArea from '@molecules/LoadingArea';
import useSearchAPIKey from '@hooks/search/useSearchAPIKey';
import useViewer from '@hooks/useViewer';

export const SearchAPIKeyContext = React.createContext();

const SearchAPIKeyProvider = ({ isAttendeeSearch = false, eventCode, children }) => {
    const { viewer } = useViewer();
    const response = useSearchAPIKey({ memberID: viewer?.recordId, isAttendeeSearch, eventCode });

    const searchAPIKey = response.data;

    if (!searchAPIKey) {
        return <LoadingArea />;
    }

    return <SearchAPIKeyContext.Provider value={{ searchAPIKey }}>{children}</SearchAPIKeyContext.Provider>;
};

SearchAPIKeyProvider.propTypes = {
    eventCode: PropTypes.string,
    isAttendeeSearch: PropTypes.bool,
    children: PropTypes.element.isRequired,
};

export default SearchAPIKeyProvider;
